import React, { useContext } from "react"
import "./FooterSectionStyle.scss"
import { footerTextContent } from "./constant/index"
import { LoginContext } from "context/context"
import { ProtectRoutesContext } from "context/ProtectRoutesContext"
import { Link } from "react-router-dom"

const Footer = () => {
  const { setOpenPasswordEntryModal } = useContext(LoginContext)
  const { isAuthenticated } = useContext(ProtectRoutesContext)

  const handleLinkClick = (e, item) => {
    if (item?.linkText === 'More' && !isAuthenticated) {
      e.preventDefault()
      setOpenPasswordEntryModal(true)
    }
  }

  return (
    <section className="footer-section">
      <div className="footer-wrap">
        <div className="footer-grid">
          {footerTextContent.content.map((section, index) => (
            <div key={index} className="footer-box">
              <h5 className="title-text">
                {section.titleText}
                <hr className="horizontal-line" />
              </h5>

              {section.linkContent && section.linkContent.length > 0 && (
                <div className="footer-link-box">
                  {section.linkContent.map((item, itemIndex) => (
                    <Link to={item?.link || '#'} className="link-item" key={itemIndex} onClick={(e) => handleLinkClick(e, item)}>
                      {item.linkText && <>{item.linkText}</>}
                    </Link>
                  ))}
                </div>
              )}

              {section.addressContent && section.addressContent.length > 0 && (
                <div className="footer-address-box">
                  {section.addressContent.map((item, itemIndex) => (
                    <p className="address-text" key={itemIndex}>
                      {item.addressTitle && (
                        <strong>{item.addressTitle}</strong>
                      )}
                      {item.addressText && <span>{item.addressText}</span>}
                    </p>
                  ))}
                </div>
              )}

              {section.iconContent && section.iconContent.length > 0 && (
                <div className="footer-icon-box">
                  {section.iconContent.map((item, itemIndex) => (
                    <a href="#" className="icon-item" key={itemIndex}>
                      {item.socialIcon && <>{item.socialIcon}</>}
                    </a>
                  ))}
                </div>
              )}
              
              {section.imageContent && section.imageContent.length > 0 && (
                <div className="footer-img-box">
                  {section.imageContent.map((item, itemIndex) => (
                    <img src={item.imageSrc} alt="Image" className={item.imageClass} key={itemIndex} />
                  ))}
                </div>
              )}              
            </div>
          ))}
        </div>

        <div className="footer-copyright">
          <p className="text">{footerTextContent.copyRightText}</p>
        </div>
      </div>
    </section>
  )
}

export default Footer
